import React, { Component, Fragment } from 'react';
import { Menu, Dropdown, Icon } from 'antd';
import {Link} from 'react-router-dom'
import axios from 'axios'

import ButtonCustom from './default/ButtonCustom'
import ShowAvatar from './default/ShowAvatar'

import { connect } from 'react-redux'
import { userLogout } from '../actions/auth'
import { fetchUserData } from '../actions/user'

class TopBar extends Component {

    onLogOutClick = () => {
        this.props.userLogout()
    }

    componentDidMount = () => {
        axios.defaults.headers.common.authorization = "Bearer "+ this.props.auth.access_token
        this.props.fetchUserData(false)
    }

    render() {
        const { name, fullname, image } = this.props.user
        const accountMenu = (
            <Menu className="dropdown-menu-wrap">
                <Menu.Item>
                    <Link to="/account" className="btn-dropdown">บัญชีผู้ใช้</Link>
                </Menu.Item>
                <Menu.Item>
                    <ButtonCustom
                        className="btn-dropdown"
                        label="ออกจากระบบ"
                        size="extra"
                        fontSize={14}
                        fontWeight="400"
                        onClick={this.onLogOutClick}
                    />
                </Menu.Item>
            </Menu>
        )

        return (
            <div className="top-bar-wrap">
                <div className="top-bar is-row">
                    <a href="/" className="logo-image">
                        <img src="/resources/images/logo-header.png" alt=""/>
                    </a>
                    <div className="is-100 is-row" style={{justifyContent: 'flex-end'}}>
                    {
                        Object.keys(this.props.user).length === 0 &&
                        <Fragment>
                            <div className="gapr-8" style={{minWidth: 120}}>
                                <ButtonCustom
                                    borderRadius="4"
                                    color="outline-blue"
                                    label="เข้าสู่ระบบ"
                                    fontSize={14}
                                    fontWeight="Bold"
                                    href="/login"
                                />
                            </div>
                            <div style={{minWidth: 120}}>
                                <ButtonCustom
                                    borderRadius="4"
                                    color="blue"
                                    label="สมัครสมาชิก"
                                    fontSize={14}
                                    fontWeight="Bold"
                                    href="/register"
                                />
                            </div>
                        </Fragment>
                    }
                    {
                        Object.keys(this.props.user).length > 0 &&
                        <Fragment>
                            <div className="action-taxt-wrap">
                                <div className="action-taxt">
                                    <Dropdown trigger={['click']} className="menubar-account" placement="bottomRight" overlay={accountMenu}>
                                        <a className="ant-dropdown-link" href="/">
                                            <ShowAvatar name={fullname} img={image} />
                                            <span className="is-desktop gapr-6">{name}</span>
                                            <Icon type="down" />
                                        </a>
                                    </Dropdown>
                                </div>
                            </div>
                        </Fragment>
                    }
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return{
        auth: state.auth,
        user: state.user,
    }
}

const mapDispatchToProps = {
    fetchUserData,
    userLogout
}

export default connect(mapStateToProps,mapDispatchToProps)(TopBar)
